import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Configuration } from '@app/common/configuration';
import { apiResponseFormat } from '@app/common/variables';
import { ReleaseConfigurationDto } from '@app/apiModules/ReleaseConfigurationDto';
import { ReleaseConfigurationMappingDto } from '../model/addOrUpdateReleaseConfigDto';
import { CSListDto } from '@app/apiModules/CSList';
import { Environment } from 'ag-grid-community';

type httpHeaderAccept = "text/plain" | "application/json" | "text/json";
@Injectable({
    providedIn: 'root'
})
export class ReleaseMgmtService {
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;
    authServerUrl = environment.API_APP_PATH;

    constructor(private readonly http: HttpClient,) {

    }
    public apiGetAllServicesAndEnvironmentDetails(
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public apiGetAllServicesAndEnvironmentDetails(
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public apiGetAllServicesAndEnvironmentDetails(
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetAllServicesAndEnvironmentDetails(
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }

        return this.http.get<ReleaseConfigurationDto>(
            `${this.authServerUrl}/api/app/release-mgmt/services-and-environment-details`,
            {
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public apiGetAllEnvironmentDetails(
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public apiGetAllEnvironmentDetails(
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public apiGetAllEnvironmentDetails(
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetAllEnvironmentDetails(
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }

        return this.http.get<ReleaseConfigurationDto>(
            `${this.authServerUrl}/api/app/environment/environments`,
            {
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    public apiGetAllServiceConfigurationDetails(
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public apiGetAllServiceConfigurationDetails(
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public apiGetAllServiceConfigurationDetails(
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetAllServiceConfigurationDetails(
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }

        return this.http.get<ReleaseConfigurationDto>(
            `${this.authServerUrl}/api/app/release-mgmt/service-info-from-master-legos`,
            {
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value).toISOString().substring(0, 10));
                } else {
                    throw Error("key may not be null if value is Date");
                }
            } else {
                httpParams = this.getHttpParamsFromObject(httpParams, value, key);
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }
    private getHttpParamsFromObject(httpParams: HttpParams, value?: any, key?: string) {
        Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        return httpParams;
    }
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    public apiGetServiceListByEnv(
        EnvString: string[],
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        
        let queryParameters = new HttpParams({ encoder: this.encoder });
        

        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        let responseType: "text" | "json" = "json";
        if (httpHeaderAcceptSelected?.startsWith("text")) {
            responseType = "text";
        }
        return this.http.post<string>(
            `${this.authServerUrl}/api/app/environment/get-environments-with-status`,
            EnvString,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public apiGetServiceListByReleaseAndEnvironment(
        releaseId: number,
        environmentId: string,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {

        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (releaseId !== undefined && releaseId !== 0) {
            queryParameters = this.addToHttpParams(queryParameters,
                <any>releaseId, 'releaseId');
        }
        if (environmentId !== undefined && environmentId !== null && environmentId !== '') {
            queryParameters = this.addToHttpParams(queryParameters,
                <any>environmentId, 'environmentId');
        }

        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        let responseType: "text" | "json" = "json";
        if (httpHeaderAcceptSelected?.startsWith("text")) {
            responseType = "text";
        }
        return this.http.get<any>(
            `${this.authServerUrl}/api/app/release-mgmt/release-services-by-environment`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    /**
     * Validates a service name by calling the backend API.
     * @param serviceName The name of the service to validate.
     * @param observe Set whether or not to return the data Observable as the body, response or events. Defaults to returning the body.
     * @param reportProgress Flag to report request and response progress.
     * @param options Additional options for the request.
     * @returns An Observable emitting the validation result as a string.
     */
    public apiValidateServiceName(
        serviceName: string,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        let responseType: "text" | "json" = "json";
        if (httpHeaderAcceptSelected?.startsWith("text")) {
            responseType = "text";
        }
        return this.http.get<string>(
            `${this.authServerUrl}/api/app/release-mgmt/validate-service-info?serviceName=${serviceName}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public apiGetServiceDataById(
        serviceId: string,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });

        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.get<any>(
            `${this.authServerUrl}/api/app/release-mgmt/service-info-by-id/${serviceId}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public apiSaveServiceConfigDetails(
        releaseConfigurationMappingDto: CSListDto,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<boolean>;
    public apiSaveServiceConfigDetails(
        releaseConfigurationMappingDto: CSListDto,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<boolean>>;
    public apiSaveServiceConfigDetails(
        releaseConfigurationMappingDto: CSListDto,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<boolean>>;
    public apiSaveServiceConfigDetails(
        releaseConfigurationMappingDto: CSListDto,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        if (
            releaseConfigurationMappingDto === null ||
            releaseConfigurationMappingDto === undefined
        ) {
            throw new Error(
                ""
            );
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.post<any>(
            `${this.authServerUrl}/api/app/release-mgmt/service-info`,
            releaseConfigurationMappingDto,
            {
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public apiUpdateServiceConfigDetails(
        releaseConfigurationMappingDto: CSListDto,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<boolean>;
    public apiUpdateServiceConfigDetails(
        releaseConfigurationMappingDto: CSListDto,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<boolean>>;
    public apiUpdateServiceConfigDetails(
        releaseConfigurationMappingDto: CSListDto,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<boolean>>;
    public apiUpdateServiceConfigDetails(
        releaseConfigurationMappingDto: CSListDto,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        if (
            releaseConfigurationMappingDto === null ||
            releaseConfigurationMappingDto === undefined
        ) {
            throw new Error(
                ""
            );
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.post<any>(
            `${this.authServerUrl}/api/app/release-mgmt/update-service-info`,
            releaseConfigurationMappingDto,
            {
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    /**
    @param versionType
    @param serviceName
 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
 * @param reportProgress flag to report request and response progress.
 */
    public apiGetVersionNumberByVersionType(
        releaseId: number,
        versionType: string,
        serviceName: string,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any>;
    public apiGetVersionNumberByVersionType(
        releaseId: number,
        versionType: string,
        serviceName: string,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpResponse<any>>;
  public apiGetVersionNumberByVersionType(
        releaseId: number,
        versionType: string,
        serviceName: string,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpEvent<any>>;
  public apiGetVersionNumberByVersionType(
        releaseId: number,
        versionType: string,
        serviceName: string,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });

        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.get<any>(
            `${this.authServerUrl}/api/app/release-mgmt/version-number-by-version-type/${releaseId}?versionType=${encodeURIComponent(String(versionType))}&serviceName=${encodeURIComponent(String(serviceName))}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public apiValidatePipelineCreationStatusVisibility(id: number, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept: undefined }): Observable<any>;
    public apiValidatePipelineCreationStatusVisibility(id: number, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept: undefined }): Observable<HttpResponse<any>>;
    public apiValidatePipelineCreationStatusVisibility(id: number, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept: undefined }): Observable<HttpEvent<any>>;
    public apiValidatePipelineCreationStatusVisibility(id: number, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept: undefined }): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiValidatePipelineCreationStatusVisibility.');
        }

        let queryParameters = new HttpParams({ encoder: this.encoder });


        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.http.post<string>(`${this.authServerUrl}/api/app/release-mgmt/validate-pipeline-creation-status-visibility/${id}`,
            null,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    public apiCheckBranchCreationStatus(id: number, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept: undefined }): Observable<any>;
    public apiCheckBranchCreationStatus(id: number, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept: undefined }): Observable<HttpResponse<any>>;
    public apiCheckBranchCreationStatus(id: number, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept: undefined }): Observable<HttpEvent<any>>;
    public apiCheckBranchCreationStatus(id: number, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept: undefined }): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiCheckBranchCreationStatus.');
        }

        let queryParameters = new HttpParams({ encoder: this.encoder });


        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        return this.http.post<string>(`${this.authServerUrl}/api/app/release-mgmt/validate-pipeline-creation-status/${id}`,
            null,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public apiGetReleaseDataById(
        releaseId: number,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });

        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.get<any>(
            `${this.authServerUrl}/api/app/release-mgmt/${releaseId}/release-configuration-details`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public fetchExistingServiceRecordbyReleaseId(
        releaseId: number,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });

        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.get<any>(

            `${this.authServerUrl}/api/app/release-mgmt/release-service-info/${releaseId}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
   * @param ReleaseConfigurationMappingDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public apiSaveReleaseDetails(
        releaseConfigurationMappingDto: ReleaseConfigurationMappingDto,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<boolean>;
    public apiSaveReleaseDetails(
        releaseConfigurationMappingDto: ReleaseConfigurationMappingDto,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<boolean>>;
    public apiSaveReleaseDetails(
        releaseConfigurationMappingDto: ReleaseConfigurationMappingDto,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<boolean>>;
    public apiSaveReleaseDetails(
        releaseConfigurationMappingDto: ReleaseConfigurationMappingDto,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        if (
            releaseConfigurationMappingDto === null ||
            releaseConfigurationMappingDto === undefined
        ) {
            throw new Error(
                "workflowQuestionnaireDto was null or undefined when calling apiAppWorkflowSchemeSaveWorkflowQuestionnaireFormDetailPost."
            );
        }
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.post<any>(
            `${this.authServerUrl}/api/app/release-mgmt/upsert-release-config`,
            releaseConfigurationMappingDto,
            {
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /*
    * @param releaseId
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public apiPostDatabaseRollbackData(
        inputRequest: any,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public apiPostDatabaseRollbackData(
        inputRequest: any,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public apiPostDatabaseRollbackData(
        inputRequest: any,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    /**
     * Sends a POST request to the server to perform a database rollback operation.
     * 
     * @param inputRequest - The request payload for the rollback operation.
     * @param observe - The type of response to observe. Defaults to "body".
     * @param reportProgress - Whether to report the progress of the request. Defaults to false.
     * @param options - Additional options for the request.
     * @param options.httpHeaderAccept - The accepted response format. Defaults to "application/json".
     * 
     * @returns An Observable that emits the response from the server.
     */
    public apiPostDatabaseRollbackData(
        inputRequest: any,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }

        return this.http.post<any>(
            `${this.authServerUrl}/api/app/release-lego-rollback-status-list/release-lego-rollback-status-list`, inputRequest,
            {
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }


    /*
    * @param releaseId
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public apiPostRollbackDbMigrationSummaryList(
        inputRequest: any,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public apiPostRollbackDbMigrationSummaryList(
        inputRequest: any,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public apiPostRollbackDbMigrationSummaryList(
        inputRequest: any,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    /**
     * Sends a POST request to the server to perform a database rollback operation.
     * 
     * @param inputRequest - The request payload for the rollback operation.
     * @param observe - The type of response to observe. Defaults to "body".
     * @param reportProgress - Whether to report the progress of the request. Defaults to false.
     * @param options - Additional options for the request.
     * @param options.httpHeaderAccept - The accepted response format. Defaults to "application/json".
     * 
     * @returns An Observable that emits the response from the server.
     */
    public apiPostRollbackDbMigrationSummaryList(
        inputRequest: any,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }

        return this.http.post<any>(
            `${this.authServerUrl}/api/app/rollback-database-migration-summary/rollback-db-migration-summary-list`, inputRequest,
            {
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /*
    * Api to initiate rollback
    */
    public apiPostInitiateRollback(
        releaseEnvironmentMappingId: any,
        releaseServiceMappingId: any,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public apiPostInitiateRollback(
        releaseEnvironmentMappingId: any,
        releaseServiceMappingId: any,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public apiPostInitiateRollback(
        releaseEnvironmentMappingId: any,
        releaseServiceMappingId: any,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    /**
     * Sends a POST request to initiate a rollback in the release management service.
     * 
     * @param releaseEnvironmentMappingId - The ID of the release environment mapping.
     * @param releaseServiceMappingId - The ID of the release service mapping.
     * @param observe - The type of response to observe. Defaults to "body".
     * @param reportProgress - Whether to report progress of the request. Defaults to false.
     * @param options - Additional options for the request.
     * @param options.httpHeaderAccept - The accepted response format. Defaults to "application/json".
     * 
     * @returns An Observable that emits the response data.
     */
    public apiPostInitiateRollback(
        releaseEnvironmentMappingId: any,
        releaseServiceMappingId: any,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        headers = headers.set("SolutionName", "ReleaseManagement");

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }

        return this.http.post<any>(
            `${this.authServerUrl}/api/app/release-mgmt/initiate-rollback?releaseEnvId=${releaseEnvironmentMappingId}&releaseServiceId=${releaseServiceMappingId}`,
            null,
            {
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public apiGetDefaultVersionNumberByVersionType(
        releaseId: number,
        versionType: string,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any>;
    public apiGetDefaultVersionNumberByVersionType(
        releaseId: number,
        versionType: string,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpResponse<any>>;
  public apiGetDefaultVersionNumberByVersionType(
        releaseId: number,
        versionType: string,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetDefaultVersionNumberByVersionType(
        releaseId: number,
        versionType: string,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });

        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.get<any>(
            `${this.authServerUrl}/api/app/release-mgmt/version-numbers-by-type-for-all-services/${releaseId}?versionType=${encodeURIComponent(String(versionType))}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    // Method to apiGetViewBranchCreationStatus release-branch-creation/fetch-branch-statuses

    public apiGetReleaseViewBranchCreationStatus(
        serviceId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any>;
    public apiGetReleaseViewBranchCreationStatus(
        serviceId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpResponse<any>>;
    public apiGetReleaseViewBranchCreationStatus(
        serviceId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetReleaseViewBranchCreationStatus(
        serviceId: number,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.get<any>(
            `${this.authServerUrl}/api/app/release-branch-creation/fetch-branch-statuses/${serviceId}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );

    }

    public apiGetReleaseStatusDetail(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any>;
    public apiGetReleaseStatusDetail(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpResponse<any>>;
    public apiGetReleaseStatusDetail(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetReleaseStatusDetail(
        releaseId: number,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {

        let queryParameters = new HttpParams({ encoder: this.encoder });
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.get<any>(
            `${this.authServerUrl}/api/app/deployment/deployment-status-by-release-id/${(releaseId)}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public apiGetAuditTrailDetail(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any>;
    public apiGetAuditTrailDetail(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpResponse<any>>;
    public apiGetAuditTrailDetail(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetAuditTrailDetail(
        releaseId: number,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {

        let queryParameters = new HttpParams({ encoder: this.encoder });
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.get<any>(
            `${this.authServerUrl}/api/app/release-mgmt/release-history-by-release-id/${(releaseId)}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public apiGetDeploymentStatusLog(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any>;
    public apiGetDeploymentStatusLog(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpResponse<any>>;
    public apiGetDeploymentStatusLog(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetDeploymentStatusLog(
        releaseId: number,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.post<any>(
            `${this.authServerUrl}/api/app/deployment/call-back-update-deployment-status-log/${releaseId}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
     public apiGetHealthStatus(
        releaseId: number,
        environmentId: string,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any>;
    public apiGetHealthStatus(
        releaseId: number,
        environmentId: string,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpResponse<any>>;
    public apiGetHealthStatus(
        releaseId: number,
        environmentId: string,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetHealthStatus(
        releaseId: number,
        environmentId: string,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        if (releaseId !== undefined && releaseId !== 0) {
            queryParameters = this.addToHttpParams(queryParameters, <any>releaseId, 'releaseId');
        }
        if (environmentId) {
            queryParameters = this.addToHttpParams(queryParameters, <any>environmentId, 'environmentId');
        }

        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = ["text/plain","application/json","text/json"];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (httpHeaderAcceptSelected?.startsWith("text")) {
            responseType = "text";
        }

        return this.http.get<any>(
            `${this.authServerUrl}/api/app/validate-health-status/health-status-by-release-id`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public apiRevalidateHealthStatus(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any>;
    public apiRevalidateHealthStatus(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpResponse<any>>;
    public apiRevalidateHealthStatus(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<HttpEvent<any>>;
    public apiRevalidateHealthStatus(
        releaseId: number,
        observe?: "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: httpHeaderAccept;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            "application/json-patch+json",
            "application/json",
            "text/json",
            "application/_*+json",
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }
        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        return this.http.post<any>(
            `${this.authServerUrl}/api/app/validate-health-status/validate-and-save-health-status/${releaseId}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    /**
     * Get Release Manifest Status by ReleaseId
     * @param releaseId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiGetReleaseManifestStatus(
        releaseId: number,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: this.encoder });
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }
        let responseType: "text" | "json" = "json";
        if (httpHeaderAcceptSelected?.startsWith("text")) {
            responseType = "text";
        }
        return this.http.get<any>(
            `${this.authServerUrl}/api/app/release-mgmt-manifest/release-manifest-status/${releaseId}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    public apiGetActiveServices(
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public apiGetActiveServices(
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public apiGetActiveServices(
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetActiveServices(
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }

        return this.http.get<ReleaseConfigurationDto>(
            `${this.authServerUrl}/api/app/release-mgmt/active-services`,
            {
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    public apiGetEnvironmentDetailsByRelease(
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public apiGetEnvironmentDetailsByRelease(
        releaseId: number,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public apiGetEnvironmentDetailsByRelease(
        releaseId: number,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    public apiGetEnvironmentDetailsByRelease(
        releaseId: number,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }

        return this.http.get<any>(
            `${this.authServerUrl}/api/app/environment/environments-by-release/${releaseId}`,
            {
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    public apiIsLatestDeployment(
        environmentId: string, 
        releaseId: number,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public apiIsLatestDeployment(
        environmentId: string,
        releaseId: number,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public apiIsLatestDeployment(
        environmentId: string,
        releaseId: number,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    public apiIsLatestDeployment(
        environmentId: string,
        releaseId: number,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }

        let queryParameters = new HttpParams({ encoder: this.encoder });
         if (releaseId !== undefined && releaseId !== 0) {
            queryParameters = this.addToHttpParams(queryParameters, <any>releaseId, 'releaseId');
        }
        if (environmentId) {
            queryParameters = this.addToHttpParams(queryParameters, <any>environmentId, 'environmentId');
        }
        
        return this.http.post<any>(
            `${this.authServerUrl}/api/app/deployment/is-latest-deployment`,  null,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
}
